import React, { useEffect, useState } from 'react';


/**
 * A reusable component that renders a generic dropdown/select element
 *
 * @param {String} title - The title/label of the dropdown
 * @param {[String]} options - Possible options of the dropdown
 * @param {Annotation} annotation - The annotation that's being updated
 * @param {String} selectedValue - The currently selected value of the dropdown
 * @param {Function} onSelectedValueChange - Function to call when the selected value changes
 * @returns {JSX} Dropdown
 */

const Dropdown = ({ title, options, annotation, onSelectedValueChange }) => {
    const [selectedOption, setSelectedOption] = useState(annotation.attributes[title])

    // Update selected option if annotation changes
    useEffect(() => {
        setSelectedOption(annotation.attributes[title])
    }, [annotation, title, options])

    const renderDropdownOptions = () => {
        if (!options) {
            return null
        }

        // ExtensionX: User can select first option and store it annotation without having to select other options first
        return (
            <>
                <option disabled value="default">-Select-</option>
                {options.map((option, index) => (
                    <option key={index} value={option}>
                        {option}
                    </option>
                ))}
            </>
        );
    };

    const handleOptionChange = (e) => {
        setSelectedOption(e.target.value)
        onSelectedValueChange && onSelectedValueChange(e.target.value)
        annotation.attributes[title] = e.target.value
    };


    return (
        <div className="dropdown-container">
            <label>{title}: </label>
            <select defaultValue="default"
                id={`${title.toLowerCase()}_dropdown`}
                value={selectedOption}
                onChange={handleOptionChange}
            >
                {renderDropdownOptions()}
            </select>
        </div>
    );
};

export default Dropdown
